import { Portal } from '../../../../shared/components/Portal';
import { useCanvasStrip } from '../../../plot/contexts/canvas-strip.context';
import { Column } from '../../../plot/contexts/column.context';
import { Plot } from '../../../plot/contexts/plot.context';
import { Row } from '../../../plot/contexts/row.context';
import { Strip } from '../../../plot/contexts/strip.context';
import { Ruler } from '../../../ruler/components/Ruler';
import { RulerContainer } from '../../../ruler/components/RulerContainer';
import {
  getDurationFromNumberOfPoints,
  SIDE_POINTS,
} from '../../client/helpers';
import { RulerInfo } from '../../../ruler/components/RulerInfo';
import { useMemo } from 'react';

export const BeatMeasurement: React.FC = () => {
  const durationToMs = useMemo(
    () => getDurationFromNumberOfPoints(2 * SIDE_POINTS),
    [],
  );
  const { foregroundRef, width, height } = useCanvasStrip();

  return (
    <Portal to={foregroundRef}>
      <Strip id='beat-plot' duration={durationToMs}>
        <svg width={width} height={height} style={{ position: 'absolute' }}>
          <Plot style={{ position: 'absolute' }}>
            <Row height={height}>
              <Column width={width}>
                <RulerContainer>
                  <Ruler />
                </RulerContainer>
                <g transform='translate(0, 15)'>
                  <RulerInfo hasRulerLock={false} />
                </g>
              </Column>
            </Row>
          </Plot>
        </svg>
      </Strip>
    </Portal>
  );
};
